import { useLazyGetPresignedUrlQuery, useUploadToS3Mutation } from 'services';

export const useUploadFileToS3 = () => {
  const [getPresignedUrl] = useLazyGetPresignedUrlQuery();
  const [uploadToS3] = useUploadToS3Mutation();

  const uploadFile = async (file: File) => {
    //  pre-signed URL
    const { preSignedURL, keyFile, fileUrl } = await getPresignedUrl({
      fileName: file.name,
      fileType: file.type,
    }).unwrap();

    // Upload file to S3
    await uploadToS3({
      preSignedURL,
      file,
      onUploadProgress: () => {},
    }).unwrap();

    return { fileUrl, keyFile };
  };

  return { uploadFile };
};
